<template>
    <div style="height: 100%;">

        <button v-if="mobile" class="btn btn-sm btn-primary mb-3" type="button" style="margin: 1vw" @click="$emit('backToSearch')">< Kembali</button>

        <div :style="(!mobile) ? 'height: 100%; padding:20px' : ''" :class="{'pageDesktop' : !mobile}">
            <div v-if="vue_universal_table.filter.brand != null">
                <h4 class="productDetailDesktop">Daftar Tipe</h4>
                <vue-universal-table
                    :api_url="'/api/v1/masterData/car/model'"
                    :disable_limit_per_page="true"
                    :filter="vue_universal_table.filter"
                    :fields="mobile ? vue_universal_table.fields_mobile : vue_universal_table.fields_desktop"
                    :update="vue_universal_table.update"
                    :sort_by="'name'"
                    :sort_order="'ASC'"
                    :indexing="true"
                ></vue-universal-table>
            </div>
            <div v-else style="text-align: center; margin:60px">
                <!-- Search and select product to begin -->
                Cari dan pilih merk untuk memulai
            </div>
        </div>
    </div>
</template>

<script>
    
    export default{
        data(){
            return{
                data : null,
                imageLink : null,
                tableTitles : [],
                vue_universal_table : {
                    filter : {
                        brand : null,
                    },
                    fields_desktop : [
                        {
                            title : 'Tipe',
                            variable : 'name'
                        },
                        {
                            title : 'Merk',
                            variable : 'brand_name'
                        }
                    ],
                    fields_mobile : [
                        {
                            title : 'ID',
                            variable : 'id'
                        },
                        {
                            title : 'Tipe',
                            variable : 'name'
                        }
                    ],
                    update : 0,
                }
            }
        },
        props:['mobile', 'detailOf', 'isUpdate'],
        mounted(){
            if(this.detailOf != null) this.vue_universal_table.filter.brand = this.detailOf;
        },
        watch:{
            'isUpdate' : function(){
                this.vue_universal_table.filter.brand = this.detailOf;
                this.vue_universal_table.update++;
            },
        },
        methods:{

        }
    }
</script>

<style scoped>
    .pageDesktop{
        border-left:1px solid #BDBDBD;
    }
    .productDetailDesktop{
        margin: 0 0 20px 20px;
        color: #616161;
    }
    .productDetailMobile{
        text-align: center;
        color: #616161;
    }
    .productImageContainer{
        width: 100%;
        padding-top: 100%; /* 1:1 Aspect Ratio */
        position: relative; /* If you want text inside of it */
        border: 1px solid black;
        border-radius: 5px;
    }
    .productImage{
        width: 100%;
        margin: auto 0;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .lightGreyHover:hover{
        background-color: #FAFAFA;
    }
</style>